import React from 'react'
import Footer from '../components/Footer'
import TeamInfo from '../components/TeamInfo'
import Navbar from '../components/Navbar'

const team = () => {
  return (
    <>
      <Navbar/>
      <div className='w-full y-screen -mt-20 md:my-0'>
          <div className='max-w-[1240px] mx-auto mt-64'>
            <TeamInfo/>
          </div>
      </div>
      <Footer/>
    </>
  )
}

export default team